<template>
    <div>
      <div>
        <el-container>
          <el-header style="background-color:white;margin-top: 5px;height: 40px;">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
              <el-form-item label="用户分类">
                <el-select v-model="formInline.type" @change="getData()" placeholder="请选择用户分类">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="起始日期">
                <el-date-picker v-model="formInline.statetime" type="datetime" value-format="timestamp" placeholder="起始日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期">
                <el-date-picker v-model="formInline.endtime" type="datetime" value-format="timestamp" placeholder="结束日期"></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="btn" @click="getData()"><i class="el-icon-search"></i>查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="danger" class="btn" @click="resetting()"><i class="el-icon-refresh"></i>重置</el-button>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main class="elMain">
            <el-table v-loading="loading" :data="tableData" height="100%" stripe border size="medium ">
              <el-table-column align="center" label="ID" prop="id" width="100"></el-table-column>
              <el-table-column align="center" label="发布人ID" prop="_id" width="300"></el-table-column>
              <el-table-column align="center" label="内容" prop="content"></el-table-column>
              <el-table-column align="center" label="发布类别" prop="type" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.type=='1'">管理者</span>
                  <span v-else>用户</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="发布时间" prop="time" width="250">
                <template slot-scope="scope">
                  <span>{{scope.row.time*1 | formatDate}}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="300">
                <template slot-scope="scope">
                  <span>
                    <el-popconfirm
                      confirmButtonText='好的'
                      cancelButtonText='不用了'
                      icon="el-icon-info"
                      iconColor="red"
                      title="这是一段内容确定删除吗？"
                      @onConfirm="deletes(scope.$index, scope.row)"
                    >
                      <el-button size="small" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <div style="padding: 15px 0;text-align: right;">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
                :page-sizes="pageSizes" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
              </el-pagination>
            </div>
          </el-footer>
        </el-container>
      </div>
    </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  import axios from 'axios' //引入axios
  export default {
    data() {
      var title = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请输入标题'))
        } else {
          callback()
        }
      }
      return {
        //
        options: [{
                  value: '',
                  label: '全部'
                }, {
                  value: '0',
                  label: '用户'
                }, {
                  value: '1',
                  label: '管理者'
                }],
        //
        content:'',
        data:'',
        tableData: [],
        loading: false,
        formInline: {
          statetime:'',
          endtime:'',
          type:'',
          pageNum:1,
          pageSize:10
        },
        pageSizes:[5, 10, 15, 20],
        pageTotal:0,
        AddForm:{
          admin_id:'',
          title:'',
          content:'',
          message_id:''
        },
        rules: {
          title: [{
            required: true,
            trigger: 'blur',
            validator: title
          }]
        },
        queryAnswers:{
          message_id:''
        },
        answer:[{"admin_name":"系统管理员","content":"测试","time":"123"}],
      }
    },

    filters: {
          formatDate: function (value) {
            /*返回总体日期*/
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            /*返回判断日期*/
            let timestamp = (new Date()).valueOf();
            let time=timestamp-value;//时间差
            let minute = 1000*60;
            let hour = minute * 60;
            var day = hour * 24;
            let times="";//内容
            let min = time/minute;//分钟
            let hours = time/hour;//天数
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
          }
        },

    created() {
      //this.getData();
    },
    //页面开启时执行
    mounted(){
      this.chark();
      this.getData();
    },
    methods: {
      //进行判定
      chark(){
        this.$emit("parentHandle", 2)
      },
      //！！！！
      //重置查询
      resetting() {
        this.formInline.type = '';
        this.formInline.statetime = '';
        this.formInline.endtime = '';
        this.getData();
      },
      //删除
      deletes(index, row) {
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        //console.log(index, row);
        commonAPI('deleteFeedback',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //查询
      getData() {
        this.loading = true,
          commonAPI('queryFeedback',this.formInline).then(res => {
            this.loading = false;
            this.tableData = res.data.data.rows;
            this.pageTotal=res.data.data.total;
            //console.log(res.data.rows);
          })
      },
      onSubmit() {
        this.getData();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline.pageSize=val;
        this.formInline.pageNum=1;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.formInline.pageNum=val;
        this.getData();
      },
    }
  }
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 5px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 20%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 700px;
    max-height: 600px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }
</style>



// WEBPACK FOOTER //
// src/admin/views/massage/APP_Feedback.vue